import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { IconButton } from "@mui/material";
import { useUserPreferences } from "../../../hooks/Preferences/useUserPreferences";

export default function ThemeIconButton() {
  const { preferences, updatePreferences } = useUserPreferences();

  const handleThemeToggle = () => {
    updatePreferences({
      ...preferences,
      theme: preferences?.theme === "dark" ? "light" : "dark",
    });
  };

  return (
    <IconButton size="small" onClick={handleThemeToggle}>
      {preferences?.theme === "dark" ? (
        <DarkModeIcon fontSize="small" />
      ) : (
        <LightModeIcon fontSize="small" />
      )}
    </IconButton>
  );
}